import styled from "@emotion/styled";
import { space, color, grid } from "styled-system";

import type { ColorProps, SpaceProps, GridProps } from "styled-system";
import type { ExactTheme } from "src/lib/emotion/theme.ts";

type Theme = Omit<ExactTheme, "buttons">;

interface GridComponentProps
  extends ColorProps<Theme>,
    SpaceProps<Theme>,
    GridProps<Theme> {}

export const Grid = styled.div<GridComponentProps>`
  display: grid;
  ${color}
  ${space}
  ${grid}
`;
